import { render, staticRenderFns } from "./InformacionInfoauto.vue?vue&type=template&id=c6f098c4&"
import script from "./InformacionInfoauto.vue?vue&type=script&lang=js&"
export * from "./InformacionInfoauto.vue?vue&type=script&lang=js&"
import style0 from "./InformacionInfoauto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VChip,VIcon})
